<template>
  <div id="main">
    <div class="banner">
      <div class="banner-text luolan-text">澜渟 洛澜</div>
      <div class="banner-text luolan-text">多功能产后治疗一体机</div>
      <div class="banner-copyright">
        广告审查批准文号：苏械广审(文)第270819-19796号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准20222090944<br/>
        请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司
      </div>
    </div>
    <div class="sanwei">
      <div class="sanwei-text luolan-text">洛澜盆底康复治疗仪</div>
      <div class="sanwei-text luolan-text">三维修复</div>
      <div class="sanwei-copyright">
        广告审查批准文号：苏械广审(文)第270814-19316号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>
        请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司
      </div>
    </div>
    <div class="sanwei-content">
      <div class="sanwei-line"></div>
      <img class="sanwei-img" :src="require('@/assets/img/product/luolan/sanwei-img.png')"/>
    </div>
    <div class="sanwei-banner">
      <div class="sanwei-banner-text luolan-text">
        三维修复
      </div>
      <div id="sanweiSwiper">
        <div class="swiper-wrapper">
          <div
              class="swiper-slide"
              v-for="(item, index) in sanweiBanner"
              :key="index"
          >
            <div class="img-container">
              <img :src="item.path" alt=""/>
              <div class="copyright" v-html="item.words"></div>
            </div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="smart-pattern">
      <div class="sp-item">
        <img class="sp-img" :src="require('@/assets/img/product/luolan/smart.png')"/>
        <div class="sp-text">治疗方案 智能定制 不套用模板</div>
        <div class="sp-sub-text">
          根据盆底受损程度和用户需求，运用AI大数据智能算法技术，智能生成专属的治疗参数，千人千面定制方案。
        </div>
        <div class="sp-copyright">
          广告审查批准文号：苏械广审(文)第270311-04523号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司
        </div>
      </div>
      <div class="sp-item">
        <img class="sp-img" :src="require('@/assets/img/product/luolan/pattern.png')"/>
        <div class="sp-text">九大训练模式</div>
        <div class="sp-sub-text">采用疗程化形式，每个疗程由多节方案组成，每节方案则由一个或多个训练模式组成。</div>
        <div class="sp-copyright">
          广告审查批准文号：苏械广审(文)第270731-17965号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>
          请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司
        </div>
      </div>
    </div>
    <div class="technology">
      <div class="technology-text luolan-text">
        三重核心技术
      </div>
      <div class="technology-list">
        <div class="technology-item">
          <img class="technology-img" :src="require('@/assets/img/product/luolan/technology-1.png')"/>
          <div class="technology-sub-text">神经肌肉电刺激</div>
          <div class="technology-text">自愈力</div>
        </div>
        <div class="technology-item">
          <img class="technology-img" :src="require('@/assets/img/product/luolan/technology-2.png')"/>
          <div class="technology-sub-text">肌电生物反馈</div>
          <div class="technology-text">运动力</div>
        </div>
        <div class="technology-item">
          <img class="technology-img" :src="require('@/assets/img/product/luolan/technology-3.png')"/>
          <div class="technology-sub-text">压力生物反馈</div>
          <div class="technology-text">耐受力</div>
        </div>
      </div>
      <div class="technology-copyright">
        广告审查批准文号：苏械广审(文)第270731-17964号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>
        请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司
      </div>
    </div>
    <div class="human">
      <div class="human-text luolan-text">更多人性化设计</div>
      <div class="human-list-1">
        <div class="human-item">
          <img class="human-img" :src="require('@/assets/img/product/luolan/human-1.png')"/>
        </div>
        <div class="human-item human-item-right">
          <img class="human-img" :src="require('@/assets/img/product/luolan/human-2.png')"/>
        </div>
        <div class="human-item">
          <img class="human-img" :src="require('@/assets/img/product/luolan/human-3.png')"/>
        </div>
      </div>
      <div class="human-list-2">
        <div class="human-item">
          <img class="human-img" :src="require('@/assets/img/product/luolan/human-4.png')"/>
        </div>
        <div class="human-item">
          <img class="human-img" :src="require('@/assets/img/product/luolan/human-5.png')"/>
        </div>
      </div>
      <div class="human-copyright">
        广告审查批准文号：苏械广审(文)第270314-04937号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>
        请仔细阅读产品说明书或者在义务人员的指导下购买和使用禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司
      </div>
    </div>
    <div class="zhuanli">
      <p class="title">国家医疗器械认证</p>
      <p class="sub-title"></p>
      <div class="list">
        <div class="item">
          <img
              v-lazy="require('@/assets/img/product/luolan/zhuanli-1.png')"
              class="img"
          />
          <p class="title">盆底康复治疗仪</p>
          <p class="desc">二类医疗器械</p>
        </div>
        <div class="item">
          <img
              v-lazy="require('@/assets/img/product/luolan/zhuanli-2.png')"
              class="img"
          />
          <p class="title">盆底康复训练软件</p>
          <p class="desc">二类医疗器械</p>
        </div>
        <div class="item">
          <img
              v-lazy="require('@/assets/img/product/luolan/zhuanli-3.png')"
              class="img"
          />
          <p class="title">阴道电极</p>
          <p class="desc">二类医疗器械</p>
        </div>
        <div class="item">
          <img
              v-lazy="require('@/assets/img/product/luolan/zhuanli-4.png')"
              class="img"
          />
          <p class="title">理疗用体表电级</p>
          <p class="desc">一类医疗器械备案</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.css";

export default {
  data() {
    return {
      sanweiSwiper: null,
      sanweiBanner: [
        {
          path: require('@/assets/img/product/luolan/sanwei-1.png'),
          words: '广告审查批准文号：苏械广审(文)第270814-19317号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司'
        },
        {
          path: require('@/assets/img/product/luolan/sanwei-2.png'),
          words: '广告审查批准文号：苏械广审(文)第270814-19319号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司'
        },
        {
          path: require('@/assets/img/product/luolan/sanwei-3.png'),
          words: '广告审查批准文号：苏械广审(文)第270731-17963号<br/>盆底康复治疗仪 医疗器械注册证编号：苏械注准 20222090944<br/>请仔细阅读产品说明书或者在医务人员的指导下购买和使用禁忌内容或者注意事项详见说明书<br/>南京麦豆健康科技有限公司'
        },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.sanweiSwiper = new Swiper("#sanweiSwiper", {
      loop: true, // 循环模式
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.banner {
  position: relative;
  width: 100%;
  height: 66.5rem;
  background: url("../../assets/img/product/luolan/banner-bg.png") no-repeat;
  background-size: cover;
  background-position-y: center;

  > .banner-text {
    text-align: center;
    position: absolute;
    top: 6rem;
    width: 100%;

    &:nth-child(2) {
      top: 8.9rem;
    }
  }

  > .banner-copyright {
    width: 100%;
    position: absolute;
    bottom: 2.2rem;
    padding: 0 2.2rem;
    font-weight: 300;
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.64);
    text-align: center;
  }
}

.sanwei {
  position: relative;
  width: 100%;
  height: 56.2rem;
  background: url("../../assets/img/product/luolan/sanwei-bg.png") no-repeat;
  background-size: cover;
  background-position-y: center;

  > .sanwei-text {
    margin-bottom: 0.12rem;
    position: absolute;
    top: 4.8rem;
    width: 100%;
    text-align: center;

    &:nth-child(2) {
      top: 7.7rem;
    }
  }

  > .sanwei-copyright {
    width: 100%;
    position: absolute;
    bottom: 4.6rem;
    padding: 0 2.2rem;
    font-weight: 300;
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.64);
    text-align: center;
  }
}

.sanwei-content {
  position: relative;
  width: 100%;
  height: 54rem;
  margin-top: -2.4rem;
  background: #EBEDFB;
  box-shadow: inset 0rem 0.4rem 0rem 0rem #7654BA;
  border-radius: 2.4rem;

  > .sanwei-line {
    position: absolute;
    width: 1.8rem;
    height: 0.2rem;
    background: #7654BA;
    top: 7.7rem;
    left: 17.85rem;
  }

  > .sanwei-img {
    margin: 4.8rem 1.6rem 0;
    width: 34.3rem;
  }
}

.sanwei-banner {
  position: relative;
  width: 100%;
  height: 65.7rem;
  background: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 4rem 1.6rem 2.8rem;

  > .sanwei-banner-text {
    text-align: center;
  }

  > #sanweiSwiper {
    width: 100%;
    height: 52.4rem;
    position: relative;
    margin: 0 auto;
    overflow: hidden;

    .swiper-slide {
      position: relative;

      > .img-container {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        > img {
          width: 100%;
        }

        > .copyright {
          font-weight: 300;
          font-size: 0.8rem;
          color: #999999;
          line-height: 1.1rem;
          padding: 0 0.6rem;
        }
      }
    }

    .swiper-pagination {
      bottom: 10.6rem;
    }

    /deep/ .swiper-pagination-bullet {
      background: transparent;     /* 改成透明 = 空心 */
      border: 0.1rem solid #fff;    /* 白色边框 */
      opacity: 1;
      margin: 0 0.6rem;
    }

    /deep/ .swiper-pagination-bullet-active {
      background: #fff;             /* 选中 = 白色实心 */
      border: 0.1rem solid transparent;
    }
  }
}

.smart-pattern {
  position: relative;
  width: 100%;
  height: 73.6rem;
  background: #fff;
  padding: 1.2rem 1.6rem 0;

  > .sp-item {
    background: #F5F5F7;
    border-radius: 2.4rem;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    margin-bottom: 4rem;

    &:last-child {
      margin-bottom: 0;
    }

    > .sp-img {
      width: 100%;
    }

    > .sp-text {
      font-weight: 500;
      font-size: 1.4rem;
      color: #000000;
      line-height: 2rem;
      margin-top: 1.2rem;
      width: 100%;
      text-align: center;
    }

    > .sp-sub-text {
      font-weight: 400;
      font-size: 1.2rem;
      color: #666666;
      text-align: center;
      line-height: 1.7rem;
      width: 100%;
      padding: 0.4rem 1.6rem 1.6rem;
    }

    > .sp-copyright {
      font-weight: 300;
      font-size: 0.6rem;
      color: rgba(255, 255, 255, 0.64);
      text-align: left;
      line-height: 0.8rem;
      position: absolute;
      bottom: 9.7rem;
      left: 1.6rem;
    }
  }
}

.technology {
  position: relative;
  width: 100%;
  background: #fafbfe;
  padding: 4rem 1.6rem 9.4rem;

  > .technology-text {
    text-align: center;
    margin-bottom: 4rem;
  }

  > .technology-list {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    row-gap: 4rem;

    > .technology-item {
      background: #F5F5F7;
      border-radius: 2.4rem;

      > .technology-img {
        width: 100%;
      }

      > .technology-sub-text {
        font-weight: 400;
        font-size: 1.4rem;
        color: #000000;
        text-align: center;
        line-height: 1.8rem;
        margin-top: 1.6rem;
      }

      > .technology-text {
        font-weight: 500;
        font-size: 1.8rem;
        color: #000000;
        text-align: center;
        line-height: 2.4rem;
        margin-bottom: 1.6rem;
      }
    }
  }

  > .technology-copyright {
    position: absolute;
    bottom: 2.8rem;
    left: 1.6rem;

    font-weight: 300;
    font-size: 0.8rem;
    line-height: 1.1rem;
    color: #999999;
    text-align: left;
  }
}

.human {
  width: 100%;
  height: 148.5rem;
  position: relative;
  background: url("../../assets/img/product/luolan/human.png") top no-repeat;
  background-size: 100%;

  > .human-text {
    position: absolute;
    top: 4rem;
    text-align: center;
    width: 100%;
  }

  > .human-list-1 {
    position: absolute;
    width: 100%;
    top: 58.5rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    row-gap: 1.6rem;
    padding: 0 1.6rem;

    > .human-item {
      width: 100%;
      height: 16.2rem;
      position: relative;

      > .human-img {
        position: absolute;
        width: 100%;
        top: 0;
      }
    }
  }

  > .human-list-2 {
    position: absolute;
    width: 100%;
    top: 112.2rem;
    display: flex;
    justify-content: space-between;
    padding: 0 1.6rem;

    > .human-item {
      position: relative;
      height: 26.9rem;
      width: 16.3rem;

      > .human-img {
        position: absolute;
        width: 100%;
        top: 0;
      }
    }
  }

  >.human-copyright {
    position: absolute;
    left: 1.6rem;
    bottom: 2.8rem;
    font-weight: 300;
    font-size: 0.8rem;
    color: #999999;
    text-align: left;
    line-height: 1.1rem;
  }
}

.zhuanli {
  position: relative;
  width: 100%;
  height: 58.3rem;
  background: #fafbfe;

  > .title {
    position: absolute;
    top: 4rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.8rem;
    color: #000000;
    line-height: 2.5rem;
    text-align: center;
  }

  > .sub-title {
    position: absolute;
    top: 6.9rem;
    width: 100%;
    font-weight: 500;
    font-size: 1.4rem;
    color: #000;
    line-height: 2rem;
    text-align: center;
  }

  > .list {
    position: absolute;
    top: 12.9rem;
    padding: 0 5.1rem 4rem 6.2rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    row-gap: 2.4rem;

    > .item {
      width: 11.62rem;

      > .img {
        width: 11.62rem;
        height: 14.72rem;
      }

      > .title {
        font-weight: 500;
        font-size: 1.3rem;
        color: #000000;
        line-height: 1.8rem;
        text-align: center;
        white-space: nowrap;
        padding-right: 0.9rem;
        margin-top: 0.9rem;
      }

      > .desc {
        font-size: 1.1rem;
        color: #999;
        line-height: 1.5rem;
        text-align: center;
        white-space: nowrap;
        padding-right: 0.9rem;
        margin-top: 0.6rem;
      }
    }
  }
}
</style>
